module.exports = "https://static.wanderu.com/ui-react/_next/static/media/hero-mobile-header.590cbe30.svg";